<template>
 <div>
     <div class="card-header col-md-12">
         <div class="row">
             <span class="col-lg-8">My Allergies</span>
             <a href="/my-health/allergies/add" class="card-action btn-link float-right col-lg-4" title="Redirect to Allergies Editing Page">
                 Edit
                 <i class="fas fa-pencil-alt"></i>
             </a>
         </div>
     </div>
     <div class="card-body gray-bg">
        <div class="row justify-content-center ">
         <div class="col-md-12">


             <ul class="list-group mb-3" v-if="als.length>0">
                 <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0" v-for="(a, key) in als" v-if="view_more || key < 4">
                     <div class="row">
                         <div class="col-md-8 sb-list-fitem-regular">
                             {{a.allergy_data?a.allergy_data.ald_name:a.all_srname}}
                         </div>
                         <div class="col-md-4 text-right sb-list-sitem">
                             <a href="#" class="text-danger" @click.prevent="deleteAlById(a)" >
                                 Remove
                             </a>
                         </div>
                     </div>
                 </li>
             </ul>


             <div v-if="als.length>4" class="text-right mb-3 mr-3">
                 <a href="#" @click.prevent="view_more=!view_more" v-if="view_more">View Less</a>
                 <a href="#" @click.prevent="view_more=!view_more" v-else>View More</a>
             </div>
             <div class="col-md-12 mb-2 text-center">
                 <a href="/my-health/allergies/add" class="btn btn-primary" title="Redirect to Allergies Adding Page">Add New Allergy</a>
             </div>
             <!-- Modal -->
             <div v-if="showModal">
                 <transition name="modal">
                     <div class="modal-mask">
                         <div class="modal-wrapper">
                             <div class="modal-dialog" role="document">
                                 <div class="modal-content">
                                     <div class="modal-header">
                                         <h5 class="modal-title"><span v-if="update">Edit </span><span v-else>Add </span>Allergy</h5>
                                         <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                             <span aria-hidden="true" @click="showModal = false">&times;</span>
                                         </button>
                                     </div>
                                     <div class="modal-body" id="al-form">
                                         <multiselect
                                                 v-model="al.all_aldid"
                                                 track-by="ald_id"
                                                 label="ald_name"
                                                 placeholder="Type to search allergy"
                                                 :searchable="true"
                                                 :allow-empty="false"
                                                 @search-change="asyncFindAllergues"
                                                 :options="searchallergies"
                                         >
                                             <template slot="noOptions">Please type to search</template>
                                         </multiselect>
                                         <div class="form-group">
                                             <input type="hidden" name="ald_id">
                                         </div>
                                     </div>
                                     <div class="modal-footer">
                                         <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>
                                         <button v-if="update" type="button" class="btn btn-danger" @click="deleteAl">Delete</button>
                                         <button v-if="!update" type="button" class="btn btn-primary" @click="saveAl">Add</button>
                                         <button v-if="update" type="button" class="btn btn-primary" @click="updateAl">Update</button>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </transition>
             </div>

         </div>
     </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:['allergies'],
        mounted() {
            this.listAl(true);
        },
        data(){
            return {
                route: '/api/allergies',
                update: false,
                showModal: false,
                searchallergies:[],
                al:{
                    id:'',
                    all_aldid:''
                },
                als:[],
                view_more: false
            }
        },
        methods:{
            asyncFindAllergues(query){
                if(query==''){
                    this.searchallergies=[]
                }else{
                    this.searchallergies=this.allergies
                }

            },
            log(s){
                console.log(s)
            },
            addAl(){
                this.showModal=true;
                this.update=false
                this.al={
                    id:'',
                    all_aldid:''
                };
            },
            saveAl(){

                this.$http.post(this.route, this.al)
                    .then(function(response) {
                        this.listAl();
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            },
            listAl(fromProp = false){
                if (fromProp) {
                    this.als = this.allergies;
                } else {
                    this.$http.get(this.route)
                        .then(function(response) {
                            this.als=response.data;
                        }, (response) => {
                            this._handleErrors(response.data, '#al-form')
                        })
                }

            },
            show(a){
                this.showModal=true;
                this.update=true
                this.al={
                    id:a.all_id,
                    all_aldid:{
                        ald_id:a.all_aldid,
                        ald_name:a.allergy_data?a.allergy_data.ald_name:a.all_srname
                    }
                };
            },
            updateAl(){
                this.$http.put(this.route, this.al)
                    .then(function(response) {
                        this.listAl();
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            },
            deleteAlById(al){
                if (!confirm('Do you really want to delete this allergy?'))
                    return
                this.$http.delete(this.route+'/'+al.all_id)
                    .then(function(response) {
                        this.listAl();
                        this.showModal=false;
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Allergy was deleted!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }

                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            },
            deleteAl(){
                this.$http.delete(this.route+'/'+this.al.id)
                    .then(function(response) {
                        this.listAl();
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#al-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
